interface InputProps {
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  autoComplete?: string;
  required?: boolean;
  disabled?: boolean;
  id?: string;
}

export function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  autoComplete,
  required,
  disabled,
  id,
}: InputProps) {
  const inputId = id ?? label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="mb-4">
      <label
        htmlFor={inputId}
        className="block text-xs uppercase tracking-wider font-mono text-ll-muted mb-1.5"
      >
        {label}
      </label>
      <input
        id={inputId}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
        className={`w-full bg-ll-bg border rounded-lg px-4 py-3 text-ll-text placeholder-ll-muted/50 focus:outline-none focus:ring-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed ${
          error
            ? 'border-ll-error focus:ring-ll-error'
            : 'border-ll-border focus:ring-ll-cyan focus:border-ll-cyan'
        }`}
      />
      {error && <p className="text-xs text-ll-error mt-1">{error}</p>}
    </div>
  );
}
